import React from 'react'
import { VideoAutoplay } from '../VideoAutoplay'
import { IProps, IVideoWithBreakpoints } from './index'
import { Image, ImagePlaceholder } from '../Image'
import LazyLoad from 'react-lazyload'
import { useMultiMediaQueries } from '../../utils'
import inPercy from '@percy-io/in-percy'
import inCypress from '../../utils/inCypress'
interface ISingleVideoProps extends Omit<IProps, 'video'> {
  video: string
}

const SingleVideo = ({
  imageRef,
  video,
  videoWebm,
  playOnce,
  mobileImage,
  forcedAnimationState,
  forcePoster = false,
  onCompleteCallback,
  getRef,
}: ISingleVideoProps) => {
  const placeholder =
    imageRef.width &&
    imageRef.height &&
    (video ? (
      <div style={{ lineHeight: '0' }}>
        <ImagePlaceholder
          width={imageRef.width}
          height={imageRef.height}
          mobileWidth={mobileImage?.width}
          mobileHeight={mobileImage?.height}
        />
      </div>
    ) : (
      <ImagePlaceholder
        width={imageRef.width}
        height={imageRef.height}
        mobileWidth={mobileImage?.width}
        mobileHeight={mobileImage?.height}
      />
    ))

  return (
    <LazyLoad offset={300} placeholder={placeholder} once>
      {video ? (
        <VideoAutoplay
          video={video}
          videoWebm={videoWebm}
          fallbackImage={imageRef}
          playOnce={playOnce}
          forcedAnimationState={forcedAnimationState}
          forcePoster={forcePoster || inPercy() || inCypress()}
          onCompleteCallback={onCompleteCallback}
          getRef={getRef}
        />
      ) : (
        <Image mobileImage={mobileImage} {...imageRef} />
      )}
    </LazyLoad>
  )
}

const VideoWithBreakpoints = ({ videos }: { videos: IVideoWithBreakpoints[] }) => {
  const currentMediaQuery = useMultiMediaQueries()

  const videoPool = videos.filter((videoProps) => currentMediaQuery.includes(videoProps.breakpoint))
  let contentProps: IVideoWithBreakpoints | null = null
  if (videoPool.length > 0) {
    contentProps = videoPool.length === 1 ? videoPool[0] : videoPool[videoPool.length - 1]
  } else {
    contentProps = videos[0]
  }

  if (contentProps) {
    const { breakpoint, fallbackImage, ...otherProps } = contentProps
    const imageRef = { url: fallbackImage }
    return (
      <div key={breakpoint} className={`video-with-breakpoints__${breakpoint}`}>
        <SingleVideo {...otherProps} imageRef={imageRef} />
      </div>
    )
  }
  return null
}

export const ImageOrAutoplayVideo = (props: IProps) => {
  const isImageOrSingleVideo = !Array.isArray(props.video)

  if (isImageOrSingleVideo) {
    return <SingleVideo {...props} video={props.video as string} />
  } else {
    return <VideoWithBreakpoints videos={props.video as IVideoWithBreakpoints[]} />
  }
}
